import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputDirective } from '@enginuity/core/forms/directives/input.directive';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'ce-form-field',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CeIconComponent, MatTooltip],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
  host: {
    '[class.invalid]': 'invalid',
    '[class.focus]': 'focus',
    '[class.standard]': '!standalone',
    '[class.label-left]': 'labelPosition === "left"',
  },
})
export class CeFormFieldComponent implements AfterContentInit {
  @Input() label: string | undefined | null;
  @Input() labelPosition: 'top' | 'left' | null = 'top';
  @Input() tooltip: string | undefined | null;
  @Input() invalid: boolean | undefined | null = false;
  @Input() standalone: boolean | undefined | null = false;

  protected focus: boolean = false;

  @ContentChildren(InputDirective, { descendants: true }) inputElements!: QueryList<InputDirective>;

  ngAfterContentInit() {
    this.inputElements.forEach((inputElement: InputDirective) => {
      inputElement.focused.subscribe(() => {
        this.handleInputFocus();
      });
      inputElement.blurred.subscribe(() => {
        this.handleInputBlur();
      });
    });
  }

  private handleInputFocus() {
    this.focus = true;
  }

  private handleInputBlur() {
    this.focus = false;
  }
}
